
// setting up handleVisibilityChange


function setupVisibilityChange() {
    $(document).on('click', ".screen-refresh a", function () {
        var url;
        if (location.href.indexOf('/en/') > 0) {
            url = location.href.split('/en/')[0] + '/en/Account/Login/?returnUrl=' + encodeURIComponent(window.location.href);
        } else {
            url = location.href.split('/fr/')[0] + '/fr/Account/Login/?returnUrl=' + encodeURIComponent(window.location.href);
        }
        window.location = url;
    });
    window.pageLoaded = new Date();
    if (typeof document.addEventListener != "undefined" && typeof document.hidden != "undefined") {
        document.addEventListener("visibilitychange", handleVisibilityChange, false);
    }

    if (window.cookieTimeout == null || window.cookieTimeout == undefined) {
        window.cookieTimeout = 20; // ensure not null
    }

    window.setTimeout(delaySessionCheck, (window.cookieTimeout+1) * 60 * 1000);
}

function handleVisibilityChange() {
    if (!document.hidden) {
        console.log("should check for session.")
        checkSession();
    } else {
        console.log("window hidden")
    }
}

function delaySessionCheck() {
    if (!$(".refresh-screen").is(":visible")) {
        checkSession();
        console.log('setting new 30 second sessioncheck ');
        window.setTimeout(delaySessionCheck, 30 * 1000);
    } 
}


function checkSession() {
    console.log('check session');
    var url;
    if (location.href.indexOf('/en/') > 0) {
        url = location.href.split('/en/')[0] + '/en/data/checksession/';
    } else {
        url = location.href.split('/fr/')[0] + '/fr/data/checksession/';
    }

    $.ajax({
        url: url,
        method: 'POST',
        contentType: false,
        processData: false,
        success: function (res) {
            console.log(res);

            if (res && res.result) {
                // user logged in
                return;
            } else {
                $(".lds-ellipsis").addClass('d-none');
                $(".loading-text").addClass('d-none');
                $(".refresh-screen").removeClass('d-none');
                $(".loadingBackground").show();
            }

        },
        error: function () {
            $(".lds-ellipsis").addClass('d-none');
            $(".loading-text").addClass('d-none');
            $(".refresh-screen").removeClass('d-none');
            $(".loadingBackground").show();
        }
    });
}
